(() => {
  const CONTAINER = '.productView-img-container.has-zoom-lens';
  const ZOOM_CLASS = 'is-zoomed';
  const ZOOM_SCALE = 2.5;
  const touchQuery = window.matchMedia('(hover: none)');
  let activeContainer = null;
  let drag = null;

  const clamp = (value) => Math.min(Math.max(value, 0), 100);

  const applyOrigin = (container, x, y) => {
    container.dataset.zoomX = x;
    container.dataset.zoomY = y;
    container.style.setProperty('--zoom-origin', `${x}% ${y}%`);
  };

  const setOriginFromPoint = (container, clientX, clientY) => {
    const rect = container.getBoundingClientRect();
    applyOrigin(
      container,
      clamp(((clientX - rect.left) / rect.width) * 100),
      clamp(((clientY - rect.top) / rect.height) * 100)
    );
  };

  const close = () => {
    if (!activeContainer) return;
    activeContainer.classList.remove(ZOOM_CLASS);
    activeContainer.removeEventListener('mouseleave', close);
    activeContainer = null;
    drag = null;
  };

  const open = (container, clientX, clientY) => {
    close();
    activeContainer = container;
    setOriginFromPoint(container, clientX, clientY);
    container.classList.add(ZOOM_CLASS);
    if (!touchQuery.matches) container.addEventListener('mouseleave', close);
  };

  const toggle = (container, clientX, clientY) => {
    if (container === activeContainer) close();
    else open(container, clientX, clientY);
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('[data-zoom-lens]');
      const container = event.target.closest(CONTAINER);

      if (button && container) {
        event.preventDefault();
        event.stopPropagation();
        const rect = container.getBoundingClientRect();
        toggle(container, rect.left + rect.width / 2, rect.top + rect.height / 2);
        return;
      }

      if (container && !touchQuery.matches) {
        event.preventDefault();
        event.stopPropagation();
        toggle(container, event.clientX, event.clientY);
        return;
      }

      if (!container) close();
    },
    true
  );

  document.addEventListener('pointerdown', (event) => {
    if (
      !activeContainer ||
      event.pointerType === 'mouse' ||
      !activeContainer.contains(event.target) ||
      event.target.closest('[data-zoom-lens]')
    )
      return;

    drag = {
      startX: event.clientX,
      startY: event.clientY,
      originX: Number(activeContainer.dataset.zoomX),
      originY: Number(activeContainer.dataset.zoomY),
    };
  });

  document.addEventListener('pointermove', (event) => {
    if (!activeContainer) return;

    if (event.pointerType === 'mouse') {
      if (activeContainer.contains(event.target)) {
        setOriginFromPoint(activeContainer, event.clientX, event.clientY);
      }
      return;
    }

    if (!drag) return;

    const rect = activeContainer.getBoundingClientRect();
    const factor = 100 / (ZOOM_SCALE - 1);
    applyOrigin(
      activeContainer,
      clamp(drag.originX - ((event.clientX - drag.startX) / rect.width) * factor),
      clamp(drag.originY - ((event.clientY - drag.startY) / rect.height) * factor)
    );
  });

  const endDrag = () => {
    drag = null;
  };

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });
})();
